import React from "react";

import { Row, Col, Container, Button } from "react-bootstrap";
import TypeWriting from "typewriter-effect";
import { SiGmail, SiLinkedin, SiGithub } from "react-icons/si";
import { motion } from "framer-motion";

import { btnVariants, iconVariants } from "../utils/motionVariants";
import bannerImage from "../assets/images/header-img.svg";
import resume from "../assets/resume/Kaamil-Ahamadh-NodeJs-Backend-Job-Resume.pdf";
import SocialIcon from "./AppComponents/SocialIcon";

const Banner = () => {
  return (
    <div id="home">
      {/* Text */}
      <Container className="text-light">
        <Row className="d-flex align-items-center">
          <Col xs={12} lg={6}>
            <span className="header text-light">Welcome to My Portfolio</span>
            <br />
            <br />
            <Container>
              <h2 className="w-100 text-center">
                I'm{" "}
                <span className="text-accent font-bold">
                  KAAMIL AHAMADH
                  <Container as="h3">
                    <TypeWriting
                      options={{
                        strings: [
                          "ReactJS Frontend Developer",
                          "NodeJS Backend Developer",
                          "ExpressJS",
                          "REST API/GraphQL API",
                          "MySQL/Postgres SQL/MongoDB",
                          "&",
                          "Javascript/Solidity Developer",
                        ],
                        autoStart: true,
                        loop: true,
                        delay: 300,
                        deleteSpeed: 100,
                      }}
                    />
                  </Container>{" "}
                </span>
              </h2>
            </Container>
            <br />
          </Col>

          {/* Image */}
          <Col xs={12} lg={6} className="text-center">
            <img src={bannerImage} alt="banner" className="banner-img" />
            <br />
            <br />
            <br />
          </Col>

          {/* Icons and Buttons */}
          <Col>
            <div className="text-center">
              <SocialIcon
                link="mailto:kaamilahamadh6@gmail.com"
                icon={<SiGmail size={23} color="cyan" />}
                newTab={false}
              />
              <SocialIcon
                link="https://github.com/kaamil-ahamadh"
                icon={<SiGithub size={23} color="cyan" />}
              />
              <SocialIcon
                link="https://linkedin.com/in/kaamil-ahamadh"
                icon={<SiLinkedin size={23} color="cyan" />}
              />
            </div>
            <br />
            <div className="text-center">

              <motion.a
                href="#contact"
                className="motion-effect"
                variants={btnVariants}
                whileHover="hover"
                whileTap="click"
                initial="rightSlideInInitial"
                viewport={{ once: true }}
                whileInView="leftSlideIn"
                transition={{
                  duration: 1,
                  delay: 1,
                }}
              >
                <Button variant="accent" className="m-2">
                  Contact Me
                </Button>
              </motion.a>
            </div>
          </Col>
          <br />
          <br />
        </Row>
      </Container>
    </div>
  );
};

export default Banner;
